import type { TournamentCreateConfig } from '../../Platform';
import { FakeOverlayTemplate } from '../FakeOverlayTemplate';

export function openFakeTournamentCreateDialog(config: TournamentCreateConfig): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    const ui = new FakeOverlayTemplate()
      .addText('TOURNAMENT CREATE')
      .addText(`score: ${config.initialScore}`)
      .addObject(config)
      .addButton('CREATE', () => {
        resolve(true);
        ui.destroy();
      })
      .addButton('CLOSE', () => {
        resolve(false);
        ui.destroy();
      });
  });
}
